import { SxProps, Theme } from '@mui/material/styles';

export const dealerServiceDetailStyles = {
    loading: {
        display: 'flex',
        justifyContent: 'center',
        mt: 8,
    } satisfies SxProps<Theme>,
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    } satisfies SxProps<Theme>,
    headerMain: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    } satisfies SxProps<Theme>,
    headerActions: {
        display: 'flex',
        gap: 1,
        flexWrap: 'wrap',
    } satisfies SxProps<Theme>,
    customerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    } satisfies SxProps<Theme>,
    sectionPaper: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
    } satisfies SxProps<Theme>,
    sectionTitle: {
        px: 3,
        py: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
    } satisfies SxProps<Theme>,
    infoRow: {
        px: 3,
        py: 2,
        display: 'grid',
        gridTemplateColumns: '160px 1fr',
        gap: 2,
    } satisfies SxProps<Theme>,
    machineRow: {
        px: 3,
        py: 2,
        display: 'grid',
        gridTemplateColumns: '160px 1fr',
        gap: 2,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    machineValue: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    } satisfies SxProps<Theme>,
    descriptionContent: {
        px: 3,
        py: 2.5,
    } satisfies SxProps<Theme>,
    processingContent: {
        px: 3,
        py: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    plannedFinishRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    } satisfies SxProps<Theme>,
    rowLabel: {
        minWidth: 160,
    } satisfies SxProps<Theme>,
    dateInput: {
        maxWidth: 220,
    } satisfies SxProps<Theme>,
    tasksList: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        mb: 1.5,
    } satisfies SxProps<Theme>,
    taskItem: {
        py: 0.75,
    } satisfies SxProps<Theme>,
    addTaskRow: {
        display: 'flex',
        gap: 1,
    } satisfies SxProps<Theme>,
    addTaskInput: {
        flex: 1,
        maxWidth: 400,
    } satisfies SxProps<Theme>,
};
